import { matchPath, useLocation } from 'react-router-dom';

type RouteParams = Record<string, string>;

export const useCustomRouteParams = <T extends RouteParams>(pathPatterns: string[]): T => {
    const location = useLocation();

    const match = pathPatterns.map((pattern) => matchPath(location.pathname, pattern)).find(Boolean);

    return (match?.params || {}) as T;
};
